import { Action } from '@ngrx/store';

export enum MandatoryNoteVisitedActionTypes {
  MANDATORY_NOTE_VISITED = '[Bpmn Process] Mandatory note visited'
}

export class MandatoryNoteVisitedAction implements Action {
  readonly type = MandatoryNoteVisitedActionTypes.MANDATORY_NOTE_VISITED;
  constructor(public payload: { elementId: string }) { }
}
